import { FC, CSSProperties } from 'react';
import { useTheme } from '@material-ui/core';
import { WbInfoTooltip } from '../../WbInfoTooltip';
import { WbBadge } from '../../WbBadge';
import { KoFilledIcon, KoIcon } from './Icons';
import { useStyles } from './style';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';

interface Props {
  filled?: boolean;
  variant?: 'reduced' | 'default';
  style?: CSSProperties;
}

export const FailedIcon: FC<Props> = ({
  filled,
  style,
  variant = 'default',
}) => {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <WbInfoTooltip
      variant={variant === 'reduced' ? undefined : 'provided-button'}
      title="Failed. You need to solve the errors reported since they will prevent the deployment"
      icon={
        variant === 'reduced' ? (
          <span>
            {filled ? (
              <KoFilledIcon
                htmlColor={theme.palette.error.main}
                className={classes.icon}
                style={style}
              />
            ) : (
              <KoIcon
                htmlColor={theme.palette.error.main}
                className={classes.icon}
                style={style}
              />
            )}
          </span>
        ) : (
          <WbBadge
            color="error"
            startIcon={<HighlightOffOutlinedIcon fontSize="small" />}
          >
            Failure
          </WbBadge>
        )
      }
    />
  );
};
